import { PhoneFormatter } from 'field-kit';
import { convertFromFullwidth } from '@square/dashboard-translations/utils/halfwidth-fullwidth-converter';
import { parsePhoneNumber, getCountryCallingCode } from 'libphonenumber-js';
export default class DefaultPhoneFormatter extends PhoneFormatter {
  constructor(countryCode = 'US') {
    super();
    this._countryCode = countryCode;
  }
  parse(text, error) {
    const parsedNumber = super.parse(convertFromFullwidth(text), error);
    if (parsedNumber) {
      return `${parsedNumber}`;
    } else {
      return '';
    }
  }
  format(text) {
    if (!text || text.length === 0) {
      return super.format(text);
    }
    if (text.startsWith(getCountryCallingCode(this._countryCode))) {
      text = `+${text}`;
    }
    try {
      const phoneNumber = parsePhoneNumber(text, this._countryCode);
      text = phoneNumber.formatNational();
    } catch {
      return text;
    }
    return text;
  }
  guessFormatFromText() {
    // avoids US-centric AsYouType formatting inherited from PhoneFormatter
    this.delimiterMap = {};
  }
  isChangeValid(change) {
    if (change.inserted.text.length <= 0 || /[\d\s()+-]+/.test(convertFromFullwidth(change.inserted.text))) {
      return super.isChangeValid(change);
    } else {
      return false;
    }
  }
}